import LabelText from 'components/text/LabelText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const InputLabelText: FunctionComponent<Props> = ({
    children,
    className = '',
    htmlFor,
    testId = TEST_ID,
    text = ''
}) => (
    <LabelText
        className={`${className} ${styles.inputLabelText}`}
        htmlFor={htmlFor}
        testId={testId}>
        {children || text}
    </LabelText>
);

InputLabelText.displayName = 'InputLabelText';

export default InputLabelText;
